import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
        @keyframes footer-pulse {0%,100% {opacity: 0.3;
transform: scaleX(0.8);}
50% {opacity: 1;
transform: scaleX(1);}}@keyframes footer-line-slide {0%,100% {transform: translateX(-100%);
background: --color-border;}
50% {transform: translateX(0);
background: --color-accent;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer__tech-line, .footer__bottom-line {
  animation: none;
}
.footer__transport-icon:hover, .footer__social-link:hover {
  transform: none;
}
.footer__social-link:hover svg {
  transform: scale(1.05);
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="footer-container6">
        <div className="footer-container7">
          <Script
            html={`<script defer data-name="footer">
(function(){
  // Staggered animation for footer elements on scroll
  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatableElements = entry.target.querySelectorAll(
            ".footer__column, .footer__brand, .footer__cta-bar, .footer__social-wrapper"
          )

          animatableElements.forEach((el, index) => {
            setTimeout(() => {
              el.style.opacity = "1"
              el.style.transform = "translateY(0)"
            }, index * 100)
          })

          footerObserver.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.1 }
  )

  const footer = document.getElementById("footer")
  if (footer) {
    const animatableElements = footer.querySelectorAll(
      ".footer__column, .footer__brand, .footer__cta-bar, .footer__social-wrapper"
    )

    animatableElements.forEach((el) => {
      el.style.opacity = "0"
      el.style.transform = "translateY(20px)"
      el.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"
    })

    footerObserver.observe(footer)
  }

  // Add active link highlighting based on current page
  const currentPath = window.location.pathname
  const footerLinks = document.querySelectorAll(".footer__link")

  footerLinks.forEach((link) => {
    if (link.getAttribute("href") === currentPath) {
      link.style.color = "var(--color-accent)"
      link.style.fontWeight = "var(--font-weight-medium)"
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <footer id="footer" className="footer">
        <div className="footer__decorative-top">
          <div className="footer__grid-overlay"></div>
          <div className="footer__tech-line"></div>
        </div>
        <div className="footer__container">
          <div className="footer__main">
            <div className="footer__brand">
              <div className="footer__logo-wrapper">
                <div className="footer__logo-accent"></div>
                <h3 className="footer__logo">ATLAS WAY GLOBAL</h3>
              </div>
              <p className="footer__tagline">
                Comprehensive Global Logistics Solutions
              </p>
              <p className="footer__description">
                {' '}
                Delivering excellence across air, sea, rail, and road freight
                transportation worldwide.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer__transport-icons">
                <div className="footer__transport-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8L4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1l3 2l2 3l1-1v-3l3-2l3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2"
                    ></path>
                  </svg>
                </div>
                <div className="footer__transport-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M12 10.189V14m0-12v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"></path>
                      <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"></path>
                      <path d="M2 21c.6.5 1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1"></path>
                    </g>
                  </svg>
                </div>
                <div className="footer__transport-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                      <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                    </g>
                  </svg>
                </div>
                <div className="footer__transport-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                      <circle cx="17" cy="18" r="2"></circle>
                      <circle cx="7" cy="18" r="2"></circle>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="footer__column">
              <h4 className="footer__column-title">Quick Links</h4>
              <ul className="footer__links">
                <li className="footer__link-item">
                  <a href="/">
                    <div className="footer__link">
                      <span>Home</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#about">
                    <div className="footer__link">
                      <span>About Us</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Our Services</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#why-choose-us">
                    <div className="footer__link">
                      <span>Why Choose Us</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#clients">
                    <div className="footer__link">
                      <span>Clients &amp; Partners</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#contact">
                    <div className="footer__link">
                      <span>Contact</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer__column">
              <h4 className="footer__column-title">Services</h4>
              <ul className="footer__links">
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Air Freight</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Sea Freight</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Rail Freight</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Road Freight</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Customs Clearance</span>
                    </div>
                  </a>
                </li>
                <li className="footer__link-item">
                  <a href="/#services">
                    <div className="footer__link">
                      <span>Warehouse &amp; Storage</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer__column">
              <h4 className="footer__column-title">Contact Us</h4>
              <div className="footer__contact">
                <div className="footer__contact-item">
                  <div className="footer__contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer__contact-details">
                    <span className="footer__contact-label">Phone</span>
                    <a href="tel:+18005559876">
                      <div className="footer__contact-link">
                        <span>
                          {' '}
                          +1 800 555 9876
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer__contact-item">
                  <div className="footer__contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                  </div>
                  <div className="footer__contact-details">
                    <span className="footer__contact-label">Email</span>
                    <a href="mailto:info@atlaswatglobal.com?subject=">
                      <div className="footer__contact-link">
                        <span>
                          {' '}
                          info@atlaswatglobal.com
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer__contact-item">
                  <div className="footer__contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer__contact-details">
                    <span className="footer__contact-label">Address</span>
                    <span className="footer__contact-text">
                      {' '}
                      1234 Logistics Blvd, Suite 500, New York, NY 10001
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="footer__contact-item">
                  <div className="footer__contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M12 6v6l4 2"></path>
                        <circle cx="12" cy="12" r="10"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="footer__contact-details">
                    <span className="footer__contact-label">Hours</span>
                    <span className="footer__contact-text">
                      24/7 Operations
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__cta-bar">
            <div className="footer__cta-content">
              <h3 className="footer__cta-title">Ready to Ship?</h3>
              <p className="footer__cta-text">
                {' '}
                Get a custom quote for your logistics needs
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <a href="/#contact">
              <div className="btn btn-accent btn-lg">
                <span>Request a Quote</span>
              </div>
            </a>
          </div>
          <div className="footer__bottom-section">
            <div className="footer__social-wrapper">
              <h4 className="footer__social-title">Follow Us</h4>
              <div className="footer__social">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    aria-label="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    aria-label="Twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    aria-label="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle cx="4" cy="4" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    aria-label="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <rect
                          width="20"
                          height="20"
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer__bottom">
              <div className="footer__copyright">
                <p> &amp; 2025 ATLAS WAY GLOBAL. All rights reserved.</p>
              </div>
              <div className="footer__legal">
                <a href="/privacy">
                  <div className="footer__legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <span className="footer__separator">|</span>
                <a href="/terms">
                  <div className="footer__legal-link">
                    <span>Terms &amp; Conditions</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__decorative-bottom">
          <div className="footer__bottom-lines">
            <div className="footer__bottom-line"></div>
            <div className="footer__bottom-line"></div>
            <div className="footer__bottom-line"></div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
